module.exports = __webpack_public_path__ + "img/kaoshinopass.0e0b293a.png";